var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81893 15.1359C10.1789 15.1358 11.5004 14.6841 12.5758 13.8516C13.6513 13.0191 14.4198 11.853 14.7607 10.5365M8.81893 15.1359C7.45894 15.1358 6.13748 14.6841 5.06204 13.8516C3.98661 13.0191 3.21811 11.853 2.8772 10.5365M8.81893 15.1359C10.513 15.1359 11.8866 12.3886 11.8866 9.00057C11.8866 5.6125 10.513 2.86523 8.81893 2.86523M8.81893 15.1359C7.1249 15.1359 5.75127 12.3886 5.75127 9.00057C5.75127 5.6125 7.1249 2.86523 8.81893 2.86523M14.7607 10.5365C14.8868 10.0456 14.9543 9.53094 14.9543 9.00057C14.956 7.94537 14.6842 6.90773 14.1655 5.9888M14.7607 10.5365C12.9427 11.5443 10.8976 12.0715 8.81893 12.0682C6.66339 12.0682 4.63804 11.5127 2.8772 10.5365M2.8772 10.5365C2.74819 10.0347 2.68314 9.51865 2.6836 9.00057C2.6836 7.90644 2.96991 6.87843 3.47233 5.9888M8.81893 2.86523C9.9071 2.86478 10.9758 3.15384 11.9154 3.70275C12.8549 4.25166 13.6316 5.04067 14.1655 5.9888M8.81893 2.86523C7.73077 2.86478 6.66208 3.15384 5.7225 3.70275C4.78293 4.25166 4.00631 5.04067 3.47233 5.9888M14.1655 5.9888C12.6812 7.27445 10.7826 7.98084 8.81893 7.97802C6.77519 7.97802 4.90595 7.22814 3.47233 5.9888",
    stroke: "white",
    strokeWidth: 1.02256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.fd99d7223052f5534acfbaa9d2541fad.svg";
export { ForwardRef as ReactComponent };